import { onKeyDown } from "../../../../service"
import classes from "./AddNewItemBtn.module.css"

const AddNewItemBtn = ({ text, upload, setAddItem, addItem }) => {


    return (
        <div>
            <div className={`${classes.ItemContainer} ${classes.AddItem} `} onClick={() => upload()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => upload())}>
                <div className={classes.AddIcon}> +</div>
                <div className={classes.AddText} >{text}</div>
            </div>
        </div>
    )
}
export default AddNewItemBtn